import React from "react";
import fondoP1 from "@/assets/FondoP1.png";
import fondoP2 from "@/assets/FondoP2.png";
import fondoP3 from "@/assets/FondoP3.png";

// Creamos una imagen compuesta horizontalmente para simular el carrusel infinito
const backgrounds = [fondoP1, fondoP2, fondoP3, fondoP1]; // Repetimos la primera para loop

export default function DynamicBackground() {
  // Creamos el string de background-image con las 4 imágenes
  const bgImages = backgrounds.map((bg) => `url(${bg})`).join(", ");

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        opacity: 0.22,
        filter: "drop-shadow(0 0 32px rgba(0,0,0,0.18))",
        backgroundImage: bgImages,
        backgroundSize: "cover",
        backgroundRepeat: "repeat-x",
        backgroundPosition: "0% 50%",
        animation: "moveBg 30s linear infinite",
      }}
    >
      <style>{`
        @keyframes moveBg {
          0% { background-position-x: 0%; }
          100% { background-position-x: -300vw; }
        }
      `}</style>
    </div>
  );
}
